// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.connected{\n\tpadding: 10px 15px; background: var(--main-success);\n\tcolor: #fff; border-radius: 3px;\n}\n.not-connected{\n\tpadding: 10px 15px; background: var(--main-danger);\n\tcolor: #fff; border-radius: 3px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
